import React from "react";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {CheckBoxItem} from "../../../../Components/Inputs/CheckboxField";
import {HtmlDisplay} from "../../../../Components/Display";
import {Button} from "../../../../Components/Inputs";

interface LoanLibraryQueueItemProps {
    details: string;
    handleDelete?: () => void;
    handleSelectedItemsChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isPendingQueue: boolean;
    isSelected?: boolean;
    loanLibraryCatalogItemId: string;
    loanLibraryQueueId: string;
    productName: string;
    [key: string]: unknown;
}

export const LoanLibraryQueueItem = ({
                                         details,
                                         handleDelete,
                                         handleSelectedItemsChange,
                                         isPendingQueue,
                                         isSelected,
                                         loanLibraryCatalogItemId,
                                         loanLibraryQueueId,
                                         productName,
                                     }: LoanLibraryQueueItemProps) => {

    return <>
        <GridContainer className={`catalog__item`} hasMarginX>

            <GridCell small_columns={gridConstants.column.TWO} medium_columns={gridConstants.column.ONE}>
                {
                    isPendingQueue &&
                    <CheckBoxItem checked={isSelected} hideLabel label={`Select ${productName}`}
                                  name={`cb${loanLibraryQueueId}`}
                                  onChange={handleSelectedItemsChange} value={loanLibraryQueueId || ''}/>
                }
            </GridCell>
            <GridCell small_columns={gridConstants.column.TEN} medium_columns={gridConstants.column.ELEVEN}>
                <h3 className={`margin--bottomNone`}>{productName}</h3>
                <HtmlDisplay html={details}/>
                {
                    handleDelete &&
                    <Button isCollapsed label={`Cancel Request`} name={`btnDelete${loanLibraryCatalogItemId}`}
                            onClick={handleDelete}/>
                }
            </GridCell>
        </GridContainer>
    </>;
};
